module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter-list"
  }, [_c('div', {
    staticClass: "outputSelectedElement",
    class: {
      active: _vm.listState
    },
    on: {
      "click": _vm.openList
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.selected.name) + "\n\t")]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listState),
      expression: "listState"
    }],
    staticClass: "list"
  }, _vm._l((_vm.filterList), function(key, index) {
    return _c('li', {
      key: key.id,
      on: {
        "click": function($event) {
          return _vm.changeChoice(index)
        }
      }
    }, [_vm._v(_vm._s(key.name))])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7beaa60f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/leafletMap/leaflet.vue
// module id = 279
// module chunks = 37